function initialCount (obj) {
  let count = 0
  for (let c in obj) {
    count++
  }
  // return count
  return count
}
function total (cart) {
  var totalPrice = 0
  for (const key in cart) {
    totalPrice += (cart[key].price * cart[key].quantity)
  }
  return totalPrice
}

export default function () {
  return {
    cart: (localStorage.getItem('cart')) ? localStorage.getItem('cart') : {},
    count: (localStorage.getItem('cart')) ? initialCount(localStorage.getItem('cart')) : 0,
    total: (localStorage.getItem('cart')) ? total(localStorage.getItem('cart')) : 0
  }
}